import React from 'react';
import ProgressReportView from '../components/ProgressReportView';

export default function ProgressReport() {
  return <ProgressReportView heading="Detailed Progress" subheading="Your learning analytics and progress overview" />;
}
